import { isValid } from '@pages/Client/Calendar/components/BulkEdit/helpers/isValidValidationNumber';

export function aIsSmallerThanB(aValue?: number, bValue?: number) {
  return isValid(aValue) && isValid(bValue) ? Number(aValue) < Number(bValue) : true;
}
